export enum TruckOwnershipType {
  Owned = 'OWNED',
  Rented = 'RENTED'
}
